module.exports = __webpack_public_path__ + "static/media/logo.792573d8.svg";